var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpacesIncidentsRankIcon = function SvgSpacesIncidentsRankIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7278 12.55C16.3821 11.4167 18.0179 11.4167 18.6722 12.55L24.5612 22.75C25.2155 23.8833 24.3976 25.3 23.089 25.3H11.311C10.0024 25.3 9.18445 23.8833 9.83878 22.75L15.7278 12.55Z",
    fill: "#F26969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0722 31.45C26.4179 32.5833 24.7821 32.5833 24.1278 31.45L18.2388 21.25C17.5845 20.1167 18.4024 18.7 19.711 18.7L31.489 18.7C32.7976 18.7 33.6155 20.1167 32.9612 21.25L27.0722 31.45Z",
    fill: "#00D52F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpacesIncidentsRankIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "spaces-incidents-rank-icon.a777d1214a38b47727953b903e0955fd.svg";